import { useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { Link } from "react-router-dom";
import CreateNewProjectView from "./CreateNewProjectView";
import { FETCH_PROJECTS } from "./graphql";
import IdeasView from "./IdeasView";

const Projects = () => {
  const { loading, error, data } = useQuery(FETCH_PROJECTS, {
    fetchPolicy: "network-only",
  });
  const modal = useModals();

  function createProjectHandler() {
    modal.present({
      title: "Create New Project",
      center: true,
      maxWidth: "max-w-3xl",
      children: <CreateNewProjectView />,
    });
  }

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const sortedProjects = [...data.projects.results].sort((a, b) => {
    return b.priority - a.priority;
  });

  return (
    <Page
      staticHeader
      title="Team Red Projects"
      rightButtons={
        <div className="flex space-x-6">
          <Button onClick={createProjectHandler}>+ New Project</Button>
          <Link to="tasks-overview">Task Overview</Link>
        </div>
      }
    >
      <div className="p-6 space-y-6">
        <div className="card p-4 py-2">
          {sortedProjects.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {sortedProjects.map((project) => (
                  <tr
                    key={project.id}
                    className="border-y border-gray-100 dark:border-gray-700"
                  >
                    <td>
                      <Link to={`${project.id}`}>
                        <span>
                          {project.priority === 2
                            ? "🔴"
                            : project.priority === 1
                              ? "🟡"
                              : "🟢"}
                        </span>
                        <span className="pl-2">{project.name}</span>
                      </Link>

                      {project.completedAt && " ✅"}

                      <span className="pl-2 font-semibold">
                        {project.owner && project.owner.firstName}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="py-2 opacity-70">No projects at the moment.</div>
          )}
        </div>

        <IdeasView />
      </div>
    </Page>
  );
};

export default Projects;
